import { makeStyles } from '@material-ui/core/styles';

export const useFormRelatedExperiencesStyles = makeStyles(theme => ({
  formExperiences: {
    flexGrow: 1
  }
}));
